import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home";
import Toxcx from "../views/Home/toxcx";
import Entrance from "../views/Home/entrance";
import Payend from "../views/Explain/payend";
import store from '@/store'

Vue.use(VueRouter);

const routes = [
  {
    path: "/detail",
    name: "Detail",
    component: () => import("@/views/Detail"),
    meta: {
      title: "景区简介",
    },
  },
  {
    path: "/explain/videoplayeok",
    name: "VideoPlayeOK",
    component: () => import("@/views/Explain/VideoPlayeOK"),
    meta: {
      title: "景区简介",
    },
  },
  {
    path: "/explain/map",
    name: "Map",
    component: () => import("@/views/Explain/map"),
    meta: {
      title: "景点位置",
    },
  },
  {
    path: "/explainZT/:id",
    name: "ExplainZT",
    component: () => import("@/views/Explain/indexZT"),
    meta: {
      title: "展厅讲解",
    },
  },

  {
    path: "/explain/:id",
    name: "Explain",
    component: () => import("@/views/Explain"),
    meta: {
      title: "金牌导览",
    },
    children: [
      {
        path: "/comment/:id",
        name: "Comment",
        component: () => import("@/views/Comment"),
        meta: {
          title: "讲解评价",
        },
      },
    ],
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    exact: true,
    meta: {
      title: "金牌导览",
    },
  },
  {
    path: "/Toxcx",
    name: "Toxcx",
    component: Toxcx,
    meta: {
      title: "跳转金牌导览小程序",
    },
  },
  {
    path: "/Entrance",
    name: "Entrance",
    component: Entrance,
    meta: {
      title: "",
    },
  },
  {
    path: "/Payend",
    name: "Payend",
    component: Payend,
    meta: {
      title: "",
    },
  },
];

const router = new VueRouter({
  routes,
  mode: "hash",
});
router.beforeEach((to, form, next) => {
  document.title = (to.meta || {}).title || document.title;
  next();
});

export default router;
